const trackingInteractions = require('@ebay/tracking-interactions');

const get = (object, path, defaultValue) => {
    if (!object) {
        return typeof defaultValue !== 'undefined' ? defaultValue : object;
    }
    let internalObject = object;
    const seg = (path.indexOf('.') !== -1) ? path.split('.') : [path];
    while (internalObject && seg.length) {
        internalObject = internalObject[seg.shift().replace(/[\[\]']+/g, '')];
    }
    return internalObject !== undefined ? internalObject : defaultValue;
};

const getTabNumber = () => {
    return document.location.hash === '#tab1' ? 1 : 0;
};

const getTrackingInteractions = (model, componentName = '') => {
    let viewportTracking;
    try {
        if (model && model.viewportTracking) {
            viewportTracking = JSON.stringify(model.viewportTracking);
        }
    } catch (err) {
        console.error(`${componentName} tracking viewport data failed to load`, err);
    }

    /* Return viewport tracking interactions */
    return trackingInteractions.viewAttributes(viewportTracking);
}

module.exports = { get, getTabNumber, getTrackingInteractions}
